/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.body.style.opacity = 1;
    document.body.classList.add('loaded');
  });
})();